import React, { useEffect, useState } from "react";
import { Button, Input, Row, Col } from "reactstrap";
import ThemeCard from "../../../Components/Common/ThemeCard";
import {
  getAllUsersApi,
  toggleUserStatusApi,
  deleteUserApi
} from "../../../api/apiUrlConst";
import { toast } from "react-toastify";
import UserTable from "../../../Components/AdminUser/UserTable";
import DeleteUserModal from "../../../Components/AdminUser/DeleteUser";
import UserFormModal from "../../../Components/AdminUser/UserFormModal";
import ResetPasswordModal from "../../../Components/AdminUser/ResetPassword";

const PAGE_SIZE = 5;

const AdminUsers: React.FC = () => {
  const [users, setUsers] = useState<any[]>([]);
  const [search, setSearch] = useState("");
  const [roleFilter, setRoleFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [deleteOpen, setDeleteOpen] = useState(false);

const [resetOpen, setResetOpen] = useState(false);
  const [formOpen, setFormOpen] = useState(false);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    const data = await getAllUsersApi();
    setUsers(data);
  };

  // 🔍 Filter Logic
  const filteredUsers = users
    .filter(u =>
      u.name.toLowerCase().includes(search.toLowerCase()) ||
      u.email.toLowerCase().includes(search.toLowerCase())
    )
    .filter(u =>
      roleFilter ? u.role === roleFilter : true
    );

  // 📄 Pagination
  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

const handleToggleStatus = async (u: any) => {
  try {
    await toggleUserStatusApi(u.userId);
    toast.success(`User ${u.isActive ? "Deactivated" : "Activated"} Successfully`);
    loadUsers();
  } catch {
    toast.error("Status update failed");
  }
};

  const handleDeleteClick = (u: any) => {
    setSelectedUser(u);
    setDeleteOpen(true);
  };

  const handleDeleteConfirm = async () => {
    await deleteUserApi(selectedUser.userId);
    toast.success("User deleted");
    setDeleteOpen(false);
    loadUsers();
  };

  const ClearFilter = () => {
    setSearch("");
    setRoleFilter("");
  }

  return (
    <div className="p-4" style={{ background: "#f4f6fb", minHeight: "100vh" }}>

  {/* ===== HEADER ===== */}
  <div
    className="d-flex justify-content-between align-items-center mb-4 p-4"
    style={{
      background: "linear-gradient(90deg, #1F3A5F, #1F3A5F)",
      borderRadius: "15px",
      color: "#fff",
    }}
  >
    <div>
      <h3 className="fw-bold mb-1">User Management</h3>
      <small>Manage users, roles & permissions</small>
    </div>

    <Button
      onClick={() => {
        setSelectedUser(null);
        setFormOpen(true);
      }}
      style={{
        background: "#fff",
        color: "#667eea",
        fontWeight: "600",
        borderRadius: "25px",
        padding: "8px 18px",
        border: "none",
      }}
    >
      + Create User
    </Button>
  </div>

  {/* ===== FILTER CARD ===== */}
  <div
    className="p-4 mb-4 shadow-sm"
    style={{
      background: "#fff",
      borderRadius: "15px",
    }}
  >
    <Row className="align-items-center g-3">
      <Col md={4}>
        <Input
          placeholder="🔍 Search users..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="rounded-pill shadow-sm"
          style={{ height: "45px" }}
        />
      </Col>

      <Col md={3}>
        <Input
          type="select"
          value={roleFilter}
          onChange={(e) => setRoleFilter(e.target.value)}
          className="rounded-pill shadow-sm"
          style={{ height: "45px" }}
        >
          <option value="">All Roles</option>
          <option>Admin</option>
          <option>Coordinator</option>
          <option>Guest</option>
        </Input>
      </Col>

      <Col>
      <Button
      color="primary"
      onClick={ClearFilter}
      >Clear</Button></Col>
    </Row>
  </div>

  {/* ===== TABLE CARD ===== */}
  <div
    className="p-4 shadow-sm"
    style={{
      background: "#fff",
      borderRadius: "15px",
    }}
  >
    <UserTable
      users={paginatedUsers}
      loading={false}
      onEdit={(u) => {
        setSelectedUser(u);
        setFormOpen(true);
      }}
      onDelete={handleDeleteClick}
      onReset={(u) => {
        setSelectedUser(u);
        setResetOpen(true);
      }}
      onToggleStatus={handleToggleStatus}
    />

    {/* ===== PAGINATION ===== */}
    <div className="d-flex justify-content-end mt-4 flex-wrap gap-2">
      {Array.from({
        length: Math.ceil(filteredUsers.length / PAGE_SIZE),
      }).map((_, i) => (
        <Button
          key={i}
          size="sm"
          onClick={() => setCurrentPage(i + 1)}
          style={{
            background:
              currentPage === i + 1
                ? "linear-gradient(90deg, #667eea, #764ba2)"
                : "#e9ecef",
            color: currentPage === i + 1 ? "#fff" : "#333",
            border: "none",
            borderRadius: "20px",
            minWidth: "35px",
          }}
        >
          {i + 1}
        </Button>
      ))}
    </div>
  </div>

  {/* ===== MODALS ===== */}
  <DeleteUserModal
    isOpen={deleteOpen}
    toggle={() => setDeleteOpen(false)}
    user={selectedUser}
    onConfirm={handleDeleteConfirm}
  />

  <UserFormModal
    isOpen={formOpen}
    toggle={() => setFormOpen(false)}
    user={selectedUser}
    refresh={loadUsers}
  />

  <ResetPasswordModal
    isOpen={resetOpen}
    toggle={() => setResetOpen(false)}
    user={selectedUser}
  />
</div>
  );
};

export default AdminUsers;   